import React from "react";

function BusinessProfileIcon({ fill = "#424242" }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1383_1813)">
        <path
          d="M16.6666 16.6668H3.33328C1.95495 16.6668 0.833282 15.5452 0.833282 14.1668V5.8335C0.833282 4.45516 1.95495 3.3335 3.33328 3.3335H16.6666C18.045 3.3335 19.1666 4.45516 19.1666 5.8335V14.1668C19.1666 15.5452 18.045 16.6668 16.6666 16.6668ZM3.33328 5.00016C2.87412 5.00016 2.49995 5.37433 2.49995 5.8335V14.1668C2.49995 14.626 2.87412 15.0002 3.33328 15.0002H16.6666C17.1258 15.0002 17.5 14.626 17.5 14.1668V5.8335C17.5 5.37433 17.1258 5.00016 16.6666 5.00016H3.33328ZM8.33328 12.5002H4.99995C4.77894 12.5002 4.56697 12.4124 4.41069 12.2561C4.25441 12.0998 4.16662 11.8878 4.16662 11.6668C4.16662 11.4458 4.25441 11.2339 4.41069 11.0776C4.56697 10.9213 4.77894 10.8335 4.99995 10.8335H8.33328C8.5543 10.8335 8.76626 10.9213 8.92254 11.0776C9.07882 11.2339 9.16662 11.4458 9.16662 11.6668C9.16662 11.8878 9.07882 12.0998 8.92254 12.2561C8.76626 12.4124 8.5543 12.5002 8.33328 12.5002ZM8.33328 9.16683H4.99995C4.77894 9.16683 4.56697 9.07903 4.41069 8.92275C4.25441 8.76647 4.16662 8.55451 4.16662 8.3335C4.16662 8.11248 4.25441 7.90052 4.41069 7.74424C4.56697 7.58796 4.77894 7.50016 4.99995 7.50016H8.33328C8.5543 7.50016 8.76626 7.58796 8.92254 7.74424C9.07882 7.90052 9.16662 8.11248 9.16662 8.3335C9.16662 8.55451 9.07882 8.76647 8.92254 8.92275C8.76626 9.07903 8.5543 9.16683 8.33328 9.16683Z"
          fill={fill}
        />
        <path
          d="M13.3334 10.4168C14.2539 10.4168 15.0001 9.67064 15.0001 8.75016C15.0001 7.82969 14.2539 7.0835 13.3334 7.0835C12.4129 7.0835 11.6667 7.82969 11.6667 8.75016C11.6667 9.67064 12.4129 10.4168 13.3334 10.4168Z"
          fill={fill}
        />
        <path
          d="M13.3333 11.1301C12.0317 11.1301 11.25 11.726 11.25 12.321C11.25 12.6185 12.0317 12.9168 13.3333 12.9168C14.555 12.9168 15.4167 12.6193 15.4167 12.321C15.4167 11.726 14.6 11.1301 13.3333 11.1301Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1383_1813">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BusinessProfileIcon;
